import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import type { DonationBenefitToastProps } from '@/app/donation/_components/DonationBenefitToast/DonationBenefitToast';
import { DonationBenefitToast } from '@/app/donation/_components/DonationBenefitToast/DonationBenefitToast';
const DONATION_BENEFIT_TOAST_ID = 'donation-benefit-toast';

/**
 * 고향사랑 기부 혜택을 알려주는 광고성 토스트
 */
export const useDonationBenefitToast = () => {
  const $ = _c(1);
  const toastDonationBenefit = _temp;
  const dismissDonationBenefitToast = _temp2;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      toastDonationBenefit,
      dismissDonationBenefitToast
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(t0) {
  const {
    theme,
    href
  } = t0;
  toast(t1 => {
    const {
      closeToast
    } = t1;
    return <DonationBenefitToast onClose={() => {
      closeToast();
    }} theme={theme} href={href} />;
  }, {
    position: "bottom-center",
    autoClose: false,
    className: "!bg-transparent !p-0 !shadow-none pointer-events-none justify-center",
    toastId: DONATION_BENEFIT_TOAST_ID
  });
}
function _temp2() {
  toast.dismiss(DONATION_BENEFIT_TOAST_ID);
}